import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import {ScrollDirection} from '../classes/scroll-manager';
import {ResponsiveSize} from "../classes/responsive-watcher";
import {getEl} from "../helpers";

export default class ResilientFuture extends Scene {

	/** Where on the screen/window does the scroll count from? 0 = Top of the window, 1 = Bottom of the window, 0.5 = Middle of the window.**/
	static WINDOW_OFFSET: number = 0.7;
	
	sectionSelector = '#resilient-future';
	mediaTimeline = anime.timeline({
		easing: 'easeInOutQuart',
		duration: 5000,
		autoplay: false,
		delay: 0,
	});

	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);
		
		const wipeDuration = 1400;
		const imageSwitchGap = 1200;
		const imageSwitchDuration = 800;
		
		const isMobile = this.manager.app.responser.isSmallerOrEqualTo(ResponsiveSize.md);
		
		this.mediaTimeline
			.add({
				targets: '.rf-wipe-1',
				
				clipPath: ['inset(100% 0% 0% 0%)', 'inset(0% 0% 0% 0%)'],
				duration: wipeDuration,
			}, 0)
			.add({
				targets: '.rf-wipe-2',
				
				clipPath: ['inset(100% 0% 0% 0%)', 'inset(0% 0% 0% 0%)'],
				duration: wipeDuration,
			}, wipeDuration * 0.33)
			.add({
				targets: '.rf-wipe-3',
				
				clipPath: ['inset(100% 0% 0% 0%)', 'inset(0% 0% 0% 0%)'],
				duration: wipeDuration,
			}, wipeDuration * 0.66)
			.add({
				targets: '.rf-wipe-1 img',
				
				scale: [1.15, 1],
				duration: wipeDuration,
			}, 0)
			.add({
				targets: '.rf-wipe-2 img',
				
				scale: [1.15, 1],
				translateY: ['10%', '0%'],
				duration: wipeDuration,
			}, wipeDuration * 0.33)
			.add({
				targets: '.rf-wipe-3 img',
				easing: "easeOutSine",
				scale: [1.15, 1],
				duration: wipeDuration,
			}, wipeDuration * 0.66)
			.add({
				targets: '.rf-blocker',
				easing: "easeInOutSine",
				opacity: [0, 1],
				duration: imageSwitchDuration,
			}, 2200)
			.add({
				targets: '.rf-clip-box',
				easing: "easeInOutSine",
				clipPath: ['inset(0% 0%)', 'inset(12% 33%)'],
				duration: imageSwitchDuration,
			}, 2200)
			.add({
				targets: '.rf-wipe-3 img',
				easing: "easeInOutQuart",
				scale: [1, 0.86],
				duration: imageSwitchDuration + 100,
			}, 2200)
			.add({
				targets: '.rf-headings',
				easing: "easeInOutQuart",
				opacity: [0, 1],
				duration: imageSwitchDuration + 100,
			}, 2200)
			.add({
				targets: '.rf-heading-1',
				easing: "easeInOutQuad",
				left: ['20%', '43%'],
				duration: imageSwitchDuration + 100,
			}, 2200)
			.add({
				targets: '.rf-heading-2',
				easing: "easeInOutQuad",
				left: ['80%', '57%'],
				duration: imageSwitchDuration + 100,
			}, 2200);
		
		if (!isMobile) {
			this.mediaTimeline
				.add({
					targets: '.rf-clip-box',
					easing: "easeInOutSine",
					clipPath: ['inset(12% 33%)', 'inset(25% 21%)'],
					duration: imageSwitchDuration,
				}, 2200 + imageSwitchGap)
				.add({
					targets: '.rf-wipe-4',
					easing: "easeInOutCirc",
					opacity: [0, 1],
					duration: imageSwitchDuration + 100,
				}, 2200 + imageSwitchGap)
				.add({
					targets: '.rf-wipe-4 img',
					easing: "easeInOutSine",
					scale: [0.9, 0.65],
					duration: imageSwitchDuration + 100,
				}, 2200 + imageSwitchGap)
				.add({
					targets: '.rf-clip-box',
					easing: "easeInOutSine",
					clipPath: ['inset(25% 21%)', 'inset(11% 35%)'],
					duration: imageSwitchDuration,
				}, 2200 + imageSwitchGap * 2)
				.add({
					targets: '.rf-wipe-5',
					easing: "easeInOutCirc",
					opacity: [0, 1],
					duration: imageSwitchDuration + 100,
				}, 2200 + imageSwitchGap * 2)
				.add({
					targets: '.rf-wipe-5 img',
					easing: "easeInOutSine",
					scale: [1, 0.8],
					duration: imageSwitchDuration + 300,
				}, 2200 + imageSwitchGap * 2)
			// .add({
			// 	targets: '.rf-clip-box',
			// 	easing: "easeInOutSine",
			// 	clipPath: ['inset(11% 35%)', 'inset(50% 35%)'],
			// 	duration: imageSwitchDuration,
			// }, 2200 + imageSwitchGap * 3.5)
			// .add({
			// 	targets: '.rf-heading-1',
			// 	easing: "easeInOutQuad",
			// 	left: '50%',
			// 	duration: imageSwitchDuration + 100,
			// }, 2200 + imageSwitchGap * 3.5)
			// .add({
			// 	targets: '.rf-heading-2',
			// 	easing: "easeInOutQuad",
			// 	left: '50%',
			// 	duration: imageSwitchDuration + 100,
			// }, 2200 + imageSwitchGap * 3.5);
		}
		
		//Uncomment this to attach an animation debugger.
		//const animDebug = new AnimationDebugger(this.mediaTimeline, getEl('#resilient-future'));
		
	}
	
	onExitedView(dir: ScrollDirection) {
	
	}

	onEnteredView(dir: ScrollDirection) {
		if (!this.mediaTimeline.completed) this.mediaTimeline.play();
	}

}
